import React, { useState, useEffect } from 'react';
import {
  Container,
  ButtonLink,
} from './styles';
import { useHistory } from 'react-router-dom';
import { Slide } from 'react-slideshow-image';
import { checkSubString } from '~/utils/utils';
import 'react-slideshow-image/dist/styles.css'

export default function CardSliderShowDefault({ banners }) {
  const host_name = window.location.host;
  const history = useHistory();

  useEffect(() => {
    const interval = setInterval(() => {
      var iframes = document.querySelectorAll('iframe');
      for (var i = 0; i < iframes.length; i++) {
        if (iframes[i].id !== 'indecx-iframe') {
          iframes[i].parentNode.removeChild(iframes[i]);
        }
      }
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    var iframes = document.querySelectorAll('iframe');
    for (var i = 0; i < iframes.length; i++) {
      if (iframes[i].id !== 'indecx-iframe') {
        iframes[i].parentNode.removeChild(iframes[i]);
      }
    }
  }, [document]);

  return (
    <Container>
      <div>
      <Slide indicators={true} pauseOnHover={false} duration={6000} >
        {banners.slice(-5).map((item) => <div className="each-slide-effect" key={item.id} >
          <div className="image" style={{ backgroundImage:  `url(${item.cover})`, height: '450px', marginTop: 10}}>
          </div>
          {item?.hiperlinks && (
            <ButtonLink className="button-more"
              style={{ cursor: 'pointer' }}
            >
              <a
                target={checkSubString(item.hiperlinks, host_name) ? "_self" : "_blank" }
                href={ item.hiperlinks}
                style={{ margin: '0px 6px 0px 16px'}}
              >
                Saiba mais
              </a>
              <i className="fa fa-caret-right fa-lg"  style={{ fontSize: '0.8rem' }} />
            </ButtonLink>
          )}
          {!item?.hiperlinks && item.content && (
            <ButtonLink className="button-more"
              onClick={() => history.push(`/segmented-comunication-details?id=${item.id}`)}
              style={{ cursor: 'pointer' }}
            >
              <a style={{ margin: '0px 6px 0px 16px'}}>
                Saiba mais
              </a>
              <i className="fa fa-caret-right fa-lg"  style={{ fontSize: '0.8rem' }} />
            </ButtonLink>
          )}
        </div>)}
      </Slide>
      </div>
    </Container>
  )
}
